// src/components/TaskModal.jsx
import { useState, useEffect } from "react";
import { format } from "date-fns";
import "../styles/modal.css";

const STATUS_OPTIONS = [
  { value: "todo", label: "Cần làm" },
  { value: "in_progress", label: "Đang làm" },
  { value: "in_review", label: "Xem xét" },
  { value: "done", label: "Hoàn thành" },
];

const PRIORITY_OPTIONS = [
  { value: "low", label: "🟢 Thấp" },
  { value: "medium", label: "🟡 Trung bình" },
  { value: "high", label: "🔴 Cao" },
];

export default function TaskModal({ task, members, onSave, onClose }) {
  const isEdit = !!task?.id;

  const [form, setForm] = useState({
    title: "",
    description: "",
    status: "todo",
    priority: "medium",
    assigneeId: "",
    deadline: "",
  });

  // Điền dữ liệu khi sửa
  useEffect(() => {
    if (task) {
      setForm({
        title: task.title || "",
        description: task.description || "",
        status: task.status || "todo",
        priority: task.priority || "medium",
        assigneeId: task.assigneeId || "",
        deadline: task.deadline?.toDate
          ? format(task.deadline.toDate(), "yyyy-MM-dd")
          : "",
      });
    }
  }, [task]);

  const set = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.title.trim()) return;
    onSave({
      ...form,
      deadline: form.deadline ? new Date(form.deadline) : null,
    });
  };

  return (
    <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <div className="modal-header">
          <h2 className="modal-title">{isEdit ? "Sửa task" : "Tạo task mới"}</h2>
          <button className="modal-close" onClick={onClose}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <path d="M18 6L6 18M6 6l12 12"/>
            </svg>
          </button>
        </div>

        <form className="modal-form" onSubmit={handleSubmit}>
          {/* Title */}
          <div className="form-group">
            <label className="form-label">Tiêu đề *</label>
            <input
              autoFocus
              value={form.title}
              onChange={set("title")}
              placeholder="Tên công việc..."
              required
            />
          </div>

          {/* Description */}
          <div className="form-group">
            <label className="form-label">Mô tả</label>
            <textarea
              value={form.description}
              onChange={set("description")}
              placeholder="Chi tiết công việc..."
              rows={3}
              style={{ resize: "vertical" }}
            />
          </div>

          {/* Row: Status + Priority */}
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Trạng thái</label>
              <select value={form.status} onChange={set("status")}>
                {STATUS_OPTIONS.map((o) => (
                  <option key={o.value} value={o.value}>{o.label}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Độ ưu tiên</label>
              <select value={form.priority} onChange={set("priority")}>
                {PRIORITY_OPTIONS.map((o) => (
                  <option key={o.value} value={o.value}>{o.label}</option>
                ))}
              </select>
            </div>
          </div>

          {/* Row: Assignee + Deadline */}
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Phân công cho</label>
              <select value={form.assigneeId} onChange={set("assigneeId")}>
                <option value="">— Chưa phân công —</option>
                {members.map((m) => (
                  <option key={m.uid} value={m.uid}>{m.displayName}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Deadline</label>
              <input
                type="date"
                value={form.deadline}
                onChange={set("deadline")}
              />
            </div>
          </div>

          {/* Actions */}
          <div className="modal-actions">
            <button type="button" className="btn-secondary" onClick={onClose}>
              Hủy
            </button>
            <button type="submit" className="btn-primary">
              {isEdit ? "Lưu thay đổi" : "Tạo task"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
